import request from '@/util/request'

const BASE_URL = '/appconfig/login'

export function verifyLoginCode() {
  return request({
    url: BASE_URL + '/verifyLoginCode.do?w=120&h=40&rc=' + Math.random(),
    method: 'get',
    responseType: 'blob'
  })
}

export function login(data) {
  const url = BASE_URL + '/login.action';
  return request.post(url, data);
}

export function getQuerColdeUrl(type){
  const url ='/appconfig/t/app/publish/apkPath?proId='+type;
  return request({
    url,
    method: 'get',
    responseType: 'blob'
  });
}
